import {
  ADD_PROJECTS,
  ADD_PROJECT,
  UPDATE_PROJECT,
  REMOVE_PROJECT,
  FETCHING_PROJECTS,
  FETCHED_PROJECTS,
  CLEAR_ALL,
} from '../constants';

interface ProjectsState {
  list: Record<string, any>;
  fetched: boolean;
  fetching: boolean;
  total: number;
}

const initialState: ProjectsState = {
  list: {},
  fetched: false,
  fetching: false,
  total: 0,
};

const projectsReducer = (state = initialState, { type, payload }: { type: string; payload?: any }): ProjectsState => {
  switch (type) {
    case FETCHING_PROJECTS:
      return { ...state, fetching: true };
    case FETCHED_PROJECTS:
      return { ...state, fetching: false };
    case ADD_PROJECTS: {
      const listMap: Record<string, any> = {};
      if (Array.isArray(payload)) {
        payload.forEach((p: any) => { listMap[p.id] = p; });
      }
      return { ...state, list: listMap, fetched: true, fetching: false, total: payload?.length || 0 };
    }
    case ADD_PROJECT: {
      const isNew = !state.list[payload.id];
      return {
        ...state,
        list: { ...state.list, [payload.id]: { ...(state.list[payload.id] || {}), ...payload } },
        total: isNew ? state.total + 1 : state.total,
      };
    }
    case UPDATE_PROJECT: {
      const existing = state.list[payload.id];
      return {
        ...state,
        list: {
          ...state.list,
          // Callers address the plan with whatever id they hold, often
          // String(projectId). Keep the stored id: letting it flip between 1
          // and '1' re-runs every effect keyed on the plan's id.
          [payload.id]: { ...(existing || {}), ...payload, id: existing?.id ?? payload.id },
        },
      };
    }
    case REMOVE_PROJECT: {
      const key = String(payload);
      if (!state.list[key]) return state;
      const { [key]: _removed, ...rest } = state.list;
      return { ...state, list: rest, total: Math.max(0, state.total - 1) };
    }
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
};

export default projectsReducer;
